import { eventBus } from '@tools/event-bus';
import { FAVORITE_PROPOSAL_EVENT } from '@molecules/constants';
import { SelectionItemEvent, Slider } from '@enums/event';
import { apiRemoveSelectionItem } from '@api/selectionItem/apiSelectionItem';
import { OFFER_EVENT } from './constants';

let locked = false;

export const initializeRefuseProposalButton = (button) => {
  const { accountManagerData, selectionItemId } = button.dataset;
  const accountManager = JSON.parse(accountManagerData);

  // Close without action
  eventBus.addEventListener(FAVORITE_PROPOSAL_EVENT.OFFER_PROPOSAL_TOGGLE_CALLBACK, () => {
    locked = false;
  });

  button.addEventListener('click', (event) => {
    event.preventDefault();
    if (!locked) {
      locked = true;
      eventBus.dispatchEvent(new CustomEvent(OFFER_EVENT.SLIDER_SHOW, {
        detail: {
          sliderType: Slider.REFUSE_SELECTION_ITEM,
          sliderPayload: {
            id: selectionItemId,
            accountManager,
          },
        },
      }));
    }
  });

  eventBus.addEventListener(OFFER_EVENT.PROPOSAL_REMOVE_LOADER, () => {
    locked = false;
  });
};

export function initSelectionItemRemoveListener() {
  eventBus.addEventListener(SelectionItemEvent.REMOVE, async (event) => {
    const { selectionItemId, refusalReasons, refusedByUser } = event.detail;

    const isRemoved = await apiRemoveSelectionItem({ selectionItemId, refusalReasons, refusedByUser });

    if (!isRemoved) {
      return;
    }

    locked = false;
    window.location.reload();
  });
}
